import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <section className="bg-background-50">
      <div className="mx-auto w-full max-w-[1240px] px-4 md:px-6 py-24 md:py-32 flex flex-col items-center text-center">
        <p className="font-heading text-6xl md:text-8xl text-primary-500">404</p>
        <h1 className="mt-6 font-heading text-2xl md:text-3xl text-foreground-950">这条看点已经翻篇了</h1>
        <p className="mt-3 max-w-md text-sm md:text-base leading-relaxed text-foreground-600">
          你访问的页面不存在或已被调整。不妨回今日看点，看看今天大家都在关注什么。
        </p>
        <div className="mt-8 flex flex-col sm:flex-row gap-3">
          <Link
            to="/today"
            className="inline-flex items-center justify-center gap-2 h-12 px-7 rounded-md bg-primary-500 text-background-50 text-sm font-medium whitespace-nowrap hover:bg-primary-600 transition-colors cursor-pointer"
          >
            <i className="ri-fire-line"></i>查看今日看点
          </Link>
          <Link
            to="/"
            className="inline-flex items-center justify-center gap-2 h-12 px-7 rounded-md border border-background-300 bg-background-50 text-foreground-900 text-sm font-medium whitespace-nowrap hover:border-primary-300 hover:text-primary-700 transition-colors cursor-pointer"
          >
            <i className="ri-home-4-line"></i>返回首页
          </Link>
        </div>
      </div>
    </section>
  );
}